import { SingleOrArray } from '@dirootie-extensions/typescript';
import { clone,concat,map,mergeAll,mergeDeepRight, mergeDeepWithKey, reduce } from 'ramda';
import { ensureArray } from 'ramda-adjunct';

const deepMerge = (toMerge:any) =>  reduce(mergeDeepWithKey((k, l, r) => k === 'columns' ? concat(l, r) : r), {},toMerge);
/**
 * Merges two objects safely by first cloning them to avoid mutations,
 * merging the cloned versions, and then freezing the result to ensure immutability.
 *
 * @param {Object} a The first object to merge.
 * @param {Object} b The second object to merge.
 * @return {Object} The merged and frozen object.
 */
export const safeMerge = <T>(a: SingleOrArray<Partial<T>>, b: Partial<T>):Partial<T> => {
  const toMerge = map(clone,[...ensureArray(a), b]);
  const merged = deepMerge(toMerge);
  return Object.freeze(merged) as Partial<T>;
};
